import axios from 'axios';
import TokenService from '../services/token.service';
import store from '../store/store';
import {
  AUTH_LOGOUT,
  LOADING_REQUEST_INCREASE,
  LOADING_REQUEST_RELEASE,
} from '../store/mutation-types';

const $http = axios.create();

const BASE_API_URL = process.env.VUE_APP_BASE_API_URL;

const Http = {
  getBaseApiUrl() {
    return BASE_API_URL;
  },
  initHeader() {
    $http.defaults.headers.common['Content-Type'] = 'application/json';

    const token = TokenService.getToken();

    if (token) {
      $http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  },
  resetHeader() {
    $http.defaults.headers.common['Content-Type'] = 'application/json';

    const token = TokenService.getToken();

    if (token) {
      $http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  },
  get(resource, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.get(`${BASE_API_URL}${resource}`, configMerged);
  },
  post(resource, data, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.post(`${BASE_API_URL}${resource}`, data, configMerged);
  },
  put(resource, data, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.put(`${BASE_API_URL}${resource}`, data, configMerged);
  },
  delete(resource, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.delete(`${BASE_API_URL}${resource}`, configMerged);
  },
};

/* Loading Interceptor */
$http.interceptors.request.use((config) => {
  if (config.loading && config.loading === true) {
    store.commit(LOADING_REQUEST_INCREASE);
  }

  return config;
}, error => Promise.reject(error));

$http.interceptors.response.use((response) => {
  if (response.config.loading && response.config.loading === true) {
    store.commit(LOADING_REQUEST_RELEASE);
  }

  return response;
}, (error) => {
  if (error.config.loading && error.config.loading === true) {
    store.commit(LOADING_REQUEST_RELEASE);
  }

  return Promise.reject(error);
});

/* Interceptor - 401 */
$http.interceptors.response.use(
  response => response,
  (error) => {
    if (error.request.status === 401) {
      // Go login page
      store.dispatch(AUTH_LOGOUT);
    }

    return Promise.reject(error);
  },
);

Http.initHeader();
export default Http;
